import { status } from 'skin/event/status';

const def = (obj, form, story, data, d, action) => {
	console.log('[def форма] событие', obj);
	return status.action;
};

export default def;
